/* eslint-disable */
import type { Money } from "../../../common/currency.pb";
import type { Channel } from "./Channel.pb";
import type { ImageAsset } from "./Image.pb";

export enum OfferType {
  OFFER_TYPE_UNSPECIFIED = "OFFER_TYPE_UNSPECIFIED",
  OFFER_TYPE_CASH_CARD_BOOST = "OFFER_TYPE_CASH_CARD_BOOST",
  OFFER_TYPE_CASH_APP_PAY_OFFER = "OFFER_TYPE_CASH_APP_PAY_OFFER",
  OFFER_TYPE_SQ_COUPON = "OFFER_TYPE_SQ_COUPON",
  OFFER_TYPE_AFTERPAY = "OFFER_TYPE_AFTERPAY",
}

export enum OfferState {
  OFFER_STATE_UNSPECIFIED = "OFFER_STATE_UNSPECIFIED",
  OFFER_STATE_INACTIVE = "OFFER_STATE_INACTIVE",
  OFFER_STATE_ACTIVE = "OFFER_STATE_ACTIVE",
  /** OFFER_STATE_DELETED - The special state that indicates the offer should be deleted. We will delete it from ES. */
  OFFER_STATE_DELETED = "OFFER_STATE_DELETED",
}

export enum TimeUnit {
  SECONDS = "SECONDS",
  HOURS = "HOURS",
  MINUTES = "MINUTES",
  DAYS = "DAYS",
  WEEKS = "WEEKS",
  MONTHS = "MONTHS",
  YEARS = "YEARS",
}

export interface Offer {
  token?: string;
  types?: OfferType[];
  state?: OfferState;
  channels?: Channel[];
  business_token?: string;
  start_at_ms?: number;
  end_at_ms?: number;
  reward_amount?: RewardAmount;
  images?: ImageAsset[];
  offer_metadata?: OfferMetadata;
  version?: number;
  in_app_browser_url?: string;
}

/**
 * This proto message is exposed directly to mobile clients via cash-suggest:
 * https://github.com/squareup/cash-suggest/blob/main/client/src/main/proto/squareup/cash/cashsuggest/api/InAppBrowserMetadata.proto
 * Any changes must be made in a way that is backwards-compatible for existing clients.
 * Ensure to get LGTMs from iOS and Android engineers before changing.
 */
export interface RewardAmount {
  reward_relative_amount?: RewardRelativeAmount | undefined;
  reward_constant_amount?: RewardConstantAmount | undefined;
}

export interface OfferMetadata {
  afterpay_offer_metadata?: AfterpayOfferMetadata | undefined;
  cash_offer_metadata?: CashOfferMetadata | undefined;
}

export interface CashOfferMetadata {
  coupon_code?: string;
  min_transaction_amount?: Money;
  rate_limit?: RateLimit;
  /** legacy boost token from rewardly */
  boost_token?: string;
  /** see https://prototype.sqprod.co/#/docs/squareup.cash.offerly.api.v2.Offer */
  max_uses_absolute?: number;
}

export interface AfterpayOfferMetadata {
  teaser?: string;
  offer_text?: string;
  cta_title?: string;
  terms?: string;
  url?: string;
  sponsored?: boolean;
  affiliate_network?: string;
  coupon_code?: string;
  min_purchase_threshold?: number;
}

/** Copied from https://github.com/squareup/cash-offerly/blob/main/proto/src/main/proto/squareup/cash/offerly/v2/reward.proto */
export interface RewardConstantAmount {
  amount?: Money;
}

export interface RewardRelativeAmount {
  basis_points?: number;
  max_reward?: Money;
}

/** Copied https://github.com/squareup/cash-offerly/blob/main/proto/src/main/proto/squareup/cash/offerly/v2/rate_limit.proto */
export interface RateLimit {
  max_uses_per_interval?: number;
  max_uses_reset_interval?: number;
  max_uses_reset_interval_unit?: TimeUnit;
}
